import SlickLightboxLayoutHelper from './SlickLightboxLayoutHelper';
import slickLightbox from './../../vendor/slick-lightbox.js';

import $ from 'jquery';

/**
 * Image Gallery Parent Class
 */
export default class GalleryPreview {

	constructor(node, index, type) {

		this.node = node;
		this.index = index;
		this.type = type;

		// default slick lightbox options
		this.slickLightboxOptions = {
			itemSelector: '.gallery-preview-'+this.index+' .detail-slideshow-trigger',
			useHistoryApi: 'true',
			background: 'rgba(255, 255, 255, 1)',
			imageMaxHeight: 0.8,
			captionPosition: 'dynamic',
			slick: {
				customPaging: function(slider, i) {
					return $('<span class="slider-pagination" />').text(i + 1);
				}
			}
		};

		this.initSlickListeners();
	}

	/**
	 *
	 * @chainable
	 */
	initSlickListeners() {
		this.node.on('show.slickLightbox', () => { this.layoutHelper.onShow() } )
	}

	/**
	 * init slick lightbox
	 *  @chainablen
	 */
	initSlickLightbox(options) {
		this.node.slickLightbox(options);
		this.layoutHelper = new SlickLightboxLayoutHelper(this.node, this.index, this.type);
		return this;
	}

	/**
	 * 
	 * 
	 */
	getOptions() {
		return this.slickLightboxOptions;
	}

	setOptions(options) {
		this.slickLightboxOptions = options;
		return this;
	}

}
